import ScheduleVisitWithMyInstitution from './ScheduleVisitWithMyInstitution';

export default ScheduleVisitWithMyInstitution;
